import script from "./Morghing.vue?vue&type=script&setup=true&lang=js"
export * from "./Morghing.vue?vue&type=script&setup=true&lang=js"

import "./Morghing.vue?vue&type=style&index=0&id=7cceb0e5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cceb0e5"]])

export default __exports__